import { render, staticRenderFns } from "./HomeSwiper.vue?vue&type=template&id=5b13f0ae&scoped=true"
import script from "./HomeSwiper.vue?vue&type=script&lang=js"
export * from "./HomeSwiper.vue?vue&type=script&lang=js"
import style0 from "./HomeSwiper.vue?vue&type=style&index=0&id=5b13f0ae&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b13f0ae",
  null
  
)

export default component.exports